import withTranslations from './with-translations-general';
export default withTranslations;
